/**
 * Base URL pública de un tenant (milinco.app/{slug} hoy; dominio custom futuro).
 * Ver docs/adr/CUSTOM_DOMAIN_SEO.md
 */
export function resolveTenantPublicBaseUrl(
  origin: string,
  publicBaseUrl?: string | null
): string {
  const custom = publicBaseUrl?.trim();
  if (custom) {
    return custom.replace(/\/$/, '');
  }
  return origin.replace(/\/$/, '');
}

/**
 * Path público del tenant. Con dominio custom el slug no va en la URL.
 */
export function buildTenantPublicPath(
  slug: string,
  segment: '' | 'tienda' | 'servicios',
  publicBaseUrl?: string | null
): string {
  const normalizedSlug = slug.trim().toLowerCase();
  const usesCustomDomain = Boolean(publicBaseUrl?.trim());

  if (usesCustomDomain) {
    if (!segment) {
      return '/';
    }
    return `/${segment}`;
  }

  if (!normalizedSlug) {
    return '/';
  }
  const encoded = encodeURIComponent(normalizedSlug);
  if (!segment) {
    return `/${encoded}`;
  }
  return `/${encoded}/${segment}`;
}
